export default "__VITE_ASSET__BSgZJZnU__"